import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Text } from '@grandvisionhq/elements';

const StoreTileText = (_param)=> {
    var { className , children  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "children"
    ]);
    return React.createElement(Text, swcHelpers.extends({}, rest, {
        className: classnames('store-tile__typography-text', className)
    }), children);
};

export { StoreTileText as default };
//# sourceMappingURL=StoreTileText.js.map
